import {Component, EventEmitter, OnInit, Output, signal} from '@angular/core';
import {HttpStatusCode} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import { ResponseHttpError, ResponseHttpSuccess, UtilService, CustomMessageService } from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {SalesWorkflowSteps, toOptionArray} from "projects/store/src/app/enums";
import {environment} from "projects/store/src/environments/environment";
import {PaymentOptions} from "projects/store/src/app/enums/payment-options";

enum AccountType {
  'cuenta-corriente'= 'Cuenta Corriente',
  'cuenta-ahorro'= 'Cuenta Ahorro'
}

@Component({
  selector: 'app-sales-payment-information-general',
  templateUrl: './sales-payment-information-general.component.html',
  styles: [
  ]
})
export class SalesPaymentInformationGeneralComponent {
  id: string;
  request: any;
  submitted: boolean = false;
  loading: boolean = false;
  country = environment.global.country;
  lukiStatus = signal<any>({});
  visibleLukiModal: boolean = false;
  visibleBankTransferModal: boolean = false;
  selectedOption: any;
  optionPayment = PaymentOptions;

  @Output() gotoStepEvent = new EventEmitter();
  @Output() nextStepEvent = new EventEmitter();

  constructor(private route: ActivatedRoute,
              private utilService: UtilService,
              private requestService: RequestService,
              private customMessageService: CustomMessageService) {
    this.id = this.route.snapshot.params['id'];
    this.request = this.requestService.request;
  }

  onContinue() {
    if (this.selectedOption === this.optionPayment["luki-client"]) {
      this.visibleLukiModal = true;
    } else if (this.selectedOption ===  this.optionPayment["banking-transfer"]) {
      this.visibleBankTransferModal = true;
    }
  }

  onGotoStep(stepCode: string) {
    this.gotoStepEvent.emit(stepCode);
  }

  onCloseLukyModal(event: boolean) {
    this.visibleLukiModal = event;
  }

  onCloseBankTransferModal(event: boolean) {
    this.visibleBankTransferModal = event;
  }

  onSetLukiStatus($event: any){
    this.lukiStatus.set($event);
    console.log(this.lukiStatus())

  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  protected readonly AccountType = toOptionArray(AccountType);
}


